<template lang="pug">
  v-container()

    v-row( justify='center' align='center' ).fill-height
      h1.font-weight-bold.my-10.mx-12.azul--text.icono-international.icono-grande.text-center( style='position: relative' v-html='Inicio.cuerpo.titulo2').pt-5.pl-7.mb-10 
  
    v-row( justify='center' align='center' ).fill-height
      Novedades(principal limit=3)

</template>
<script>
import { mapState } from 'vuex'
export default {
  data: ()=>({
  }),
  computed: {
    Inicio() {
      return this.$contenido.Inicio || {}
    },
    ...mapState({
      Reglas: ({Ayudas})=>Ayudas.reglas,
      
    }),
  },
  components: {
    Novedades: ()=>import('../novedades/Contenido')
  }
}
</script>